<template>
    <div class="file-uploader">
        <drop-area
            v-if="showDropzone"
            :drop-options="dropOptions"
            @fileSaved="dropzoneAdd"
            @fileDelete="dropzoneRemove"
            @error="$emit('error', $event)"
        >
            <template v-slot:title>
                <slot name="title"></slot>
            </template>
            <template v-slot:description>
                <slot name="description"></slot>
            </template>
        </drop-area>

        <media-list
            v-if="showList"
            :files="filesToShowInList"
            :locale="locale"
            @delete="remove($event)"
            :style="(showDrop && filesToShowInList.length > 0) ? 'margin-top: 20px' : ''"
            :allow-delete="allowDelete"
            v-bind="this.mediaListOptions"
            class="uploader-media-list"
        >

            <template #media-item="{ data }">
                <slot name="media-item" v-bind:data="data"></slot>
            </template>

        </media-list>
    </div>
</template>

<script>
import FileUploaderBase from '../common/FileUploaderBase'
import {
    getFileInfo,
    getThumbnailUrl
} from '../../repositories/defaultRepository'
import { sanitizeUrl } from '../../services/helpers'
import DropArea from '../common/DropArea'
import File from '../common/File'
import uploaderProps from '../../mixins/uploaderProps'
import MediaList from './MediaList/index'

export default {
    extends: FileUploaderBase,
    mixins: [uploaderProps],
    name: 'FileUploader',
    components: {
        DropArea,
        MediaList
    },
    computed: {
        dropOptions() {
            return {
                ...this.dropzoneOptions,
                ...this.translations,
                url: sanitizeUrl(`${this.baseURL}/media/upload`),
                headers: {
                    Authorization: this.auth
                }
            }
        },
        savedFiles() {
            return this.proxyFiles.map(f => f.serverUuid)
        }
    },
    watch: {
        filesToFetch: {
            deep: true,
            immediate: true,
            handler(files) {
                for (let file of files) {
                    file.isFetchingInfo = true
                    getFileInfo(file.serverUuid).then(({ data }) => {
                        const idx = this.proxyFiles.findIndex(
                            f => f.serverUuid === data.uuid
                        )

                        this.proxyFiles[idx].name = data.name
                        this.proxyFiles[idx].ext = data.ext
                        this.proxyFiles[idx].size = data.size
                        this.proxyFiles[idx].mimeType = data.mimeType
                        this.proxyFiles[idx].isFetchingInfo = false

                        if (this.proxyFiles[idx].isImage()) {
                            this.proxyFiles[idx].thumbnailUrl = getThumbnailUrl(
                                data.uuid
                            )
                        }
                    })
                }
            }
        },
        value: {
            deep: true,
            immediate: true,
            handler(files) {
                for (let serverUuid of files) {
                    // skip existing files
                    if (
                        false ===
                        this.proxyFiles
                            .map(f => f.serverUuid)
                            .includes(serverUuid)
                    ) {
                        this.proxyFiles.push(
                            new File(serverUuid, null, null, null, null, null)
                        )
                    }
                }
            }
        }
    },
    methods: {
        dropzoneAdd({ file, response }) {
            const f = new File(
                response.uuid,
                null,
                file.name.split('.')[0],
                file.name.split('.').pop(),
                file.size,
                file.type
            )
            if (f.isImage()) {
                f.thumbnailUrl = getThumbnailUrl(f.serverUuid)
            }
            this.proxyFiles.push(f)
            this.afterFileAdd(f)
            this.$emit('fileAdded', f)
        },

        dropzoneRemove(fileUuid) {
            const subject = this.proxyFiles.find(({serverUuid}) => serverUuid === fileUuid)
            if (!subject) {
                return
            }

            this.proxyFiles = this.proxyFiles.filter(file => {
                return file.serverUuid !== subject.serverUuid
            })

            this.$emit('fileRemoved', subject)
        },

        reset() {
            this.proxyFiles = []
        }
    }
}
</script>

<style lang="scss">
@import '~vue2-dropzone/dist/vue2Dropzone.min.css';
@import '~font-awesome/css/font-awesome.css';
@import '~vue-cool-lightbox/dist/vue-cool-lightbox.min.css';
@import '../../assets/scss/main.scss';
</style>
